import React from 'react';
import PropTypes from 'prop-types';

function Book (props) {
  const bookData = props.book;
  return (
    <li>
      <div className="book-item">
        <div className="book" onClick={(e) => props.setShowModal(e, true, bookData)}>
          <img src={(bookData.image_url ? bookData.image_url : "https://alan-static-assets.s3.amazonaws.com/vilib/BOOK_COVER_2.png")}
               alt={bookData.title || ""}
          />
        </div>
      </div>
    </li>
  )
}


Book.propTypes = {
  book: PropTypes.object.isRequired,
};

export default Book;